// extracted by mini-css-extract-plugin
export default {"titlePage":"permissionDefault_titlePage__UYbIg"};